import { Types } from '../actions/materialActions';
import convertArrayToObject from '../../utils/arrayOp';
import { sc } from '../../utils/Common';

const initialState = {
  filterKey: '',
  historicalFilter: 0,
  filtered: [],
  loading: false,
  error: '',
  selected: [],
  Data: []
};

const filterAll = (filterKey, data) => {
  const newFiltered =
    filterKey.length === 0
      ? data
      : data.filter(
          row =>
            sc(row.MaterialCode, filterKey) ||
            sc(row.MaterialDesc, filterKey) ||
            sc(row.Ref, filterKey)
        );
  return newFiltered;
};

export const materialReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_MATERIAL_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }

    case Types.GET_HISTORICAL_MATERIAL_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }

    case Types.RESET_MATERIALS: {
      return {
        ...initialState,
        loading: false
      };
    }

    case Types.ADD_MATERIALS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case Types.GET_MATERIAL_SUCCESS: {
      return {
        ...state,
        error: '',
        filtered: action.payload,
        loading: false,
        materialsTable: convertArrayToObject(action.payload, 'MaterialCode'),
        Data: action.payload,
        ...action.selectedMaterials
      };
    }
    case Types.SET_MATERIAL_ERROR: {
      return {
        ...state,
        ...action.payload,
        error: action.payload.error,
        loading: false
      };
    }
    case Types.SET_MATERIAL_SELECTION: {
      return {
        ...state,
        [action.payload.defect]: [...action.payload.item]
      };
    }
    case Types.SET_MATERIAL_QUAN: {
      return {
        ...state,
        [action.payload.material]: action.payload.value
      };
    }
    case Types.SET_MATERIAL_FILTER_KEY: {
      const key = action.payload.value;
      const newFiltered =
        key.length === 0
          ? state.Data
          : state.Data.filter(
              row => sc(row.MaterialCode, key) || sc(row.MaterialDesc, key) || sc(row.Ref, key)
            );
      return {
        ...state,
        filterKey: key,
        filtered: newFiltered
      };
    }

    default:
      return state;
  }
};
